export type RequestType = 'get' | 'post' | 'put' | 'patch' | 'delete'
